import React, { useState } from 'react';

import JobTabCalender from '@app/Schedule/JobCalender/jobTabCalender';

const WorkPackers = () => {
    //  ask fore type

    const [viewName, setViewName] = useState<string>('Weekly Packer View');

    return (
        <div className="px-4 mt-5">
            <JobTabCalender
                type={'packer'}
                setViewName={setViewName}
                viewName={viewName}
            />
        </div>
    );
};

export default WorkPackers;
